import { LABELS } from '@/constants/common/message.constants'

import { type TruckEntity } from '../..'

/**
 * 車両の利用タイプ
 */
export type TruckUsageType = TruckEntity['usageType']

export const TRUCK_USAGE_TYPE = {
  /** スポット */
  SPOT: 'SPOT',
  /** レギュラー */
  REGULAR: 'REGULAR'
} as const satisfies Record<TruckUsageType, TruckUsageType>

export const TRUCK_USAGE_TYPE_LABEL = {
  [TRUCK_USAGE_TYPE.SPOT]: LABELS.SPOT,
  [TRUCK_USAGE_TYPE.REGULAR]: LABELS.REGULAR
} as const satisfies Record<TruckUsageType, string>
